import axios from "axios";
import { config } from "../config";
import { authenticate } from "./interceptors";

export const schedulerApi = axios.create({ baseURL: config.scheduler.url });

schedulerApi.interceptors.request.use(authenticate);
